import React from 'react'
import { AnimateSharedLayout, motion } from 'framer-motion'
import {
  animationAppTransitions,
  animationAppVariants
} from '../component/Helpers/pageAnimation'
import { HelpLayout } from '../component/Help/HelpLayout'

const HelpPage: React.FC = () => {
  const Page: React.FC = () => {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={animationAppVariants}
        transition={animationAppTransitions}
      >
        <div style={{ position: 'relative' }}>
          <HelpLayout />
        </div>
      </motion.div>
    )
  }

  return (
    <AnimateSharedLayout>
      <Page />
    </AnimateSharedLayout>
  )
}

export default HelpPage
